import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './checkout.css';
import MobFullAreaCheckout from './mobile/mobControllerPage';
import DesktopFullAreaCheckout from './desktop/desktopControllerPage';
//import registerServiceWorker from './registerServiceWorker';

//Create a token when the checkout page is opened and store it in a seperate table with a validity of 8 minutes, that token should be sent alongwith all the requests made to the web api.

if (/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
	ReactDOM.render(<MobFullAreaCheckout />, document.getElementById('full_checkout'));
}else{
	ReactDOM.render(<DesktopFullAreaCheckout />, document.getElementById('full_checkout'));
}

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js